import { Redirect, RouteProps } from "react-router";
import Profile from "../pages/Profile";
import MyUsers from "../pages/MyUsers";
import MyPatients from "../pages/MyPatients";
import MyRequests from "../pages/MyRequests";
import Groups from "../pages/Groups";
import Agenda from "../pages/Agenda";
import Dashboard from "../pages/JourneesDepistage/dashboard";
import Planning from "../pages/JourneesDepistage/planning";
import Facturation from "../pages/JourneesDepistage/facturation";
import Contributeurs from "../pages/JourneesDepistage/contributeurs";
const medecinResponsableRoutes: RouteProps[] = [
  {
    path: "/mes-patients",
    component: MyPatients,
    exact: true,
  },

  {
    path: "/groupes",
    component: Groups,
    exact: true,
  },
  {
    path: "/users",
    component: MyUsers,
    exact: true,
  },
  {
    path: "/demandes",
    component: MyRequests,
    exact: true,
  },
  {
    path: "/profile",
    component: Profile,
    exact: true,
  },

  {
    path: "/disponibilités",
    component: Agenda,
    exact: true,
  },
  {
    path: "/journeesdepistage/dashboard",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/journeesdepistage/planning",
    component: Planning,
    exact: true,
  },
  {
    path: "/journeesdepistage/facturation",
    component: Facturation,
    exact: true,
  },
  {
    path: "/journeesdepistage/contributeurs",
    component: Contributeurs,
    exact: true,
  },
  
  { render: () => <Redirect to="/users" /> },
];

export default medecinResponsableRoutes;
